import React, { useState } from 'react';
import { Button as But, IconButton as IBut, CircularProgress, Icon, Menu, MenuItem, Tooltip, Link } from '@mui/material';
import Colors from '../../styles/colors';
import useStyles from './styles';
import { merge, get } from 'global/lib/lodash';
import colors from '../../styles/colors';

export const Button = (props) => {
  const { loading, startIcon, bgColor, color, classes, icon, ...rest } = props;
  const _bgColor = bgColor || color || Colors.blue;
  const _classes = useStyles({ ...rest, bgColor: _bgColor == 'default' ? Colors.defaultGrey : _bgColor });
  const clss = merge({}, _classes, classes);
  let [_loading, setLoading] = useState(false);

  const onClick = async (e) => {
    if (_loading) {
      return;
    }
    try {
      _loading = true;
      setLoading(true);
      props.onClick && (await props.onClick(e));
    } finally {
      _loading = false;
      setLoading(false);
    }
  };

  const ico = (() => {
    const icoobj = startIcon || icon;
    if (typeof icoobj === 'string') {
      return <Icon>{icoobj}</Icon>;
    }
    return icoobj;
  })();

  const allowColor = ['primary', 'secondary'].includes(color) ? color : undefined;

  return (
    <But {...rest} color={allowColor} variant={props.variant === 'none' ? undefined : props.variant || 'contained'} startIcon={ico} onClick={onClick} classes={clss}>
      {props.title || props.children}
      {(loading || _loading) && <CircularProgress size={12} />}
    </But>
  );
};

export const IconButton = (props) => {
  const [_loading, setLoading] = useState(false);
  const { loading, startIcon, bgColor, color, classes, icon, loadingProps, ...rest } = props;

  const _bgColor = bgColor || color || 'default';
  const _classes = useStyles({ ...rest, bgColor: _bgColor == 'default' ? Colors.defaultGrey : _bgColor });
  const clss = merge({}, _classes, classes);

  const onClick = async (e) => {
    try {
      setLoading(true);
      props.onClick && (await props.onClick(e));
    } finally {
      setLoading(false);
    }
  };

  const ico = (() => {
    const icoobj = startIcon || icon;
    if (typeof icoobj === 'string') {
      return <Icon>{icoobj}</Icon>;
    } else if (icoobj) {
      return icoobj;
    }
    return props.children;
  })();

  const Comp = (
    <IBut {...rest} onClick={onClick} classes={clss}>
      {loading || _loading ? <CircularProgress size={12} {...(loadingProps || {})} /> : ico}
    </IBut>
  );

  if (rest.toolTip) {
    return (
      <Tooltip title={rest.toolTip}>
        <span>{Comp}</span>
      </Tooltip>
    );
  }

  return Comp;
};

export const ButtonDrop = (props) => {
  const { startIcon, ...rest } = props;
  const [state, setState] = useState({
    anchor: null,
  });

  const onClick = (e) => {
    setState((s) => ({ ...s, anchor: e.target }));
  };

  const onClose = () => {
    setState((s) => ({ ...s, anchor: null }));
  };

  const onSelect = (opt) => {
    props.onSelect && props.onSelect(opt);
    onClose();
  };

  const opts = get(props, 'options', []);

  return (
    <>
      <Button {...rest} onClick={onClick} />
      <Menu id="simple-menu" anchorEl={state.anchor} keepMounted open={Boolean(state.anchor)} onClose={onClose}>
        {opts.map((opt, i) => (
          <MenuItem {...opt} onClick={() => onSelect(opt)}>
            {opt.title || opt.children}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export const LinkButton = (props) => {
  return (
    <Button {...props} style={{ textTransform: 'none' }} variant="default" textColor={colors.blue}>{props.children}</Button>
  )
}